import Pagination from "react-bootstrap/Pagination";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import StateHelper from "../utils/StateHelper";

interface PaginationButtonsProps {
  size: number;
  currentPage: number;
  setCurrentPage: (newCurrentPage:number) => void;
  pageSize: number;
  setPageSize: (newPageSize:number) => void;
}

function PaginationButtons(props: PaginationButtonsProps) {

  const maxPages = getMaxPages();

  let pages = [];
  for (let i = 1; i <= maxPages; i++) {
    let obj = <option key={"o" + i}>{i}</option>;
    pages.push(obj);
  }

  const pageSizes = [25, 50, 100, 150, 200].map( s => <option key={"ps" + s.toString()}>{s}</option>);
  const numberFormat = new Intl.NumberFormat();

  function getMaxPages(): number {
    let maxPages = Math.floor(props.size / props.pageSize);
    let difference = props.size % props.pageSize;
    if (difference > 0) {
      maxPages++;
    }
    return maxPages;
  }

  function nextPage() {
    let maxPages = getMaxPages();
    let next = props.currentPage + 1;
    if (next <= maxPages) {
      props.setCurrentPage(next);
    }
  }

  function previousPage() {
    let prev = props.currentPage - 1;
    if (prev > 0) {
      props.setCurrentPage(prev);
    }
  }

  function pageChanged(e: any) {
    props.setCurrentPage(parseInt(e.target.value));
  }

  function pageSizeChanged(e: any) {
    try {
      StateHelper.setLocalStorageItem("dashboard.pageSize",e.target.value);
    } catch (error) {
      console.log(error);
    }
    
    props.setPageSize(parseInt(e.target.value));
    props.setCurrentPage(1);
  }

  function changePage(value: any) {
    props.setCurrentPage(value);
  }

  if (props.size === 0) {
    return (
      <Row className="align-items-center mb-3">
        <Col xl={1} />
        <Col xl={10} className="d-flex align-items-center justify-content-center">
          <span className="fw-normal">
            No results found. Rows returned: 0
          </span>
        </Col>
        <Col xl={1} />
      </Row>
    );
  }

  return (
    <Row className="align-items-center mb-3">
      <Col xl={1} />

      <Col xl={3} className="d-flex align-items-center">
        <span className="fw-normal">
          Page: {numberFormat.format(props.currentPage)} of {numberFormat.format(maxPages)}. Rows returned: {numberFormat.format(props.size)}
        </span>
      </Col>

      <Col xs="auto" className="d-flex align-items-center">
        <span className="me-2 mr-2 text-nowrap" style={{ lineHeight: "1.5rem" }}>Page size</span>
        <Form.Control
          as="select"
          size="sm"
          onChange={pageSizeChanged}
          value={props.pageSize}
          className="align-middle"
        >
          {pageSizes}
        </Form.Control>
      </Col>

      {maxPages !== 1 ? (
        <Col xl={4} className="d-flex align-items-center">
          <div className="d-flex align-items-center gap-2">
            <Pagination size="sm" className="mb-0">
              <Pagination.First onClick={() => changePage(1)}>First</Pagination.First>
              <Pagination.Prev onClick={previousPage}>Previous</Pagination.Prev>
            </Pagination>

            <Form.Control
              as="select"
              size="sm"
              onChange={pageChanged}
              value={props.currentPage}
              style={{ width: "50px" }}
            >
              {pages}
            </Form.Control>

            <Pagination size="sm" className="mb-0">
              <Pagination.Next onClick={nextPage}>Next</Pagination.Next>
              <Pagination.Last onClick={() => changePage(maxPages)}>Last</Pagination.Last>
            </Pagination>
          </div>
        </Col>
      ) : (
        <Col xl={4}></Col>
      )}

      <Col xl={1} />
    </Row>
  );
}

export default PaginationButtons;
